import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    var id = '0b47c28a-6e1f-4bd4-81e6-7842c7bf4b07';
    
    if (document.querySelector("body.business.index")) {
      id = "915c70e1-f3ea-4be0-9afa-cac26a1f9a5b";
    }

    new PCWidget({c: id, f: true });
  }
}
